<template>
  <div id="inici">
    <Menu ref="menu"/>
    <MenuResponsive></MenuResponsive>
    <div class="bg positions-relative">
      <div class="container bg-container">
        <div class="premis-zirkolika">
          <img  src="../assets/logos/zirkotica_orange.svg" style=""/>
        </div>
        <ComingSoon v-if="agenda" :agenda="agenda[0]"></ComingSoon>
      </div>
      <div class="position-absolute logo">
        <img class="mt-4" src="../assets/logos/Logo-cia-nom-provisional-definitiu-Blanc.png"/>
      </div>
    </div>
    <Sinopsi></Sinopsi>
    <Galeria :galeria="galeria1"></Galeria>
    <Fitxa></Fitxa>
    <Video></Video>
    <Companyia></Companyia>
    <Galeria :galeria="galeria2"></Galeria>
    <Agenda :agenda="agenda"></Agenda>
    <Contacte></Contacte>
    <Footer></Footer>
  </div>
</template>

<script>
// @ is an alias to /src
import Menu from '@/components/Menu.vue';
import axios from 'axios';
import ComingSoon from '../components/ComingSoon.vue';
import Sinopsi from '../components/Sinopsi.vue';
import Galeria from '../components/Galeria.vue';
import Fitxa from '../components/Fitxa.vue';
import Video from '../components/Video.vue';
import Companyia from '../components/Companyia.vue';
import Agenda from '../components/Agenda.vue';
import Contacte from '../components/Contacte.vue';
import MenuResponsive from '../components/MenuResponsive.vue';
import Footer from '../components/Footer.vue';

import galeria1 from '../assets/galeria1.json';
import galeria2 from '../assets/galeria2.json';

const metaByLocale = {
  ca: {
    lang: 'ca',
    title: 'Cia Nom Provisional — Companyia de circ',
    description: 'Circ amb perxa xinesa i bicicleta acrobàtica. El nom no és provisional. Companyia de circ del Maresme.',
  },
  es: {
    lang: 'es',
    title: 'Cia Nom Provisional — Compañía de circo',
    description: 'Circo con pértica china y bicicleta acrobática. El nombre no es provisional. Compañía de circo del Maresme.',
  },
  en: {
    lang: 'en',
    title: 'Cia Nom Provisional — Circus Company',
    description: 'Circus with Chinese pole and acrobatic bicycle. The name is not provisional. Circus company from Maresme.',
  },
};

export default {
  name: 'Home',
  metaInfo() {
    const meta = metaByLocale[this.$i18n.locale] || metaByLocale.ca;
    return {
      title: meta.title,
      htmlAttrs: { lang: meta.lang },
      meta: [
        { name: 'description', content: meta.description },
        { property: 'og:title', content: meta.title },
        { property: 'og:description', content: meta.description },
        { property: 'og:type', content: 'website' },
        { property: 'og:url', content: `https://www.cianomprovisional.com/${this.$i18n.locale === 'ca' ? '' : this.$i18n.locale}` },
        { property: 'og:locale', content: meta.lang },
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: meta.title },
        { name: 'twitter:description', content: meta.description },
        { name: 'twitter:image', content: 'https://www.cianomprovisional.com/img/bg1.d466683b.jpg' },
      ],
    };
  },
  components: {
    Menu,
    ComingSoon,
    Sinopsi,
    Galeria,
    Fitxa,
    Video,
    Companyia,
    Agenda,
    Contacte,
    MenuResponsive,
    Footer,
  },
  data() {
    return {
      galeria1,
      galeria2,
      agendaRaw: [],
      yearsAvaliable: Array.from({ length: new Date().getFullYear() - 2018 + 1 }, (_, i) => String(new Date().getFullYear() - i)),
    };
  },
  mounted() {
    console.log('%cCia Nom provisional \nDistribució :\ninfo@lamaleta.cat \nCompanyia :\nhola@cianomprovisional.com', 'font-size: 35px; color: #ff6633;background-color:#00338c;padding:1rem;width:100%');
    this.loadEvents();
  },
  computed: {
    agenda() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.agendaRaw.sort((a, b) => b.year - a.year);
    },
  },
  methods: {
    async loadEvents() {
      this.yearsAvaliable.forEach((year) => {
        const date = new Date(year);
        const lastDate = new Date(date.getFullYear(), 12, 31);
        // RFC 3339 format
        const timeMinFormatted = date.toISOString();
        const timeMaxFormatted = lastDate.toISOString();
        axios
          .get(`https://www.googleapis.com/calendar/v3/calendars/i2ckmq329k9ssn9tk4lui0a58g@group.calendar.google.com/events?key=AIzaSyDeXrQwT_IBlixOXpnOqEg8bAbbpNYlT-o&orderBy=startTime&singleEvents=true&timeMin=${timeMinFormatted}&timeMax=${timeMaxFormatted}`)
          // eslint-disable-next-line no-return-assign
          .then((response) => {
            const data = {
              // eslint-disable-next-line radix
              year: parseInt(year),
              data: response.data.items,
            };
            this.agendaRaw.push(data);
            this.test = 2;
          });
      });
    },
  },
};
</script>
